import { faArrowsRotate, faListCheck, faShieldHalved, faUser } from '@fortawesome/free-solid-svg-icons';
import { faChartNetwork, faHandshake, faBuildings, faHouseBlank } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const getIcon = (icon) => {
  switch (icon) {
    case 'faListCheck':
      return faListCheck;
    case 'faShieldHalved':
      return faShieldHalved;
    case 'faChartNetwork':
      return faChartNetwork;
    case 'faUser':
      return faUser;
    case 'faHandshake':
      return faHandshake;
    case 'faBuildings':
      return faBuildings;
    case 'faHouseBlank':
      return faHouseBlank;
    case 'faArrowsRotate':
      return faArrowsRotate;
    default:
      return faListCheck;
  }
};

export const getMenuIcon = (icon) => {
  // check first two chars
  // if (fa) the return <FontAwedpme icon
  //if http then <img src=...
  // mui then Muiicon
  let iconName = icon.substring(0, 2);

  if (iconName === 'fa') {
    return <FontAwesomeIcon icon={getIcon(icon)} />;
  } else if (iconName == 'ht') {
    return <img src={icon} />;
  }
};
